/* -----------------------------------------------------------------------------
 * Wizard SM Actions
 *
 * @description - Actions of Wizard SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

export default {

  /**
   * Before each coordinator
   * @description Returns appropriate route params
   */
  beforeEachCoordinator ({ getters, rootGetters }, { name, step, verify }) {
    if (!verify) return undefined // public route => just next()
    if (!rootGetters['moduleSecurity/isTokenVerified']) return { name: 'init' } // not verified yet or invalid token
    if (!step) return undefined // route is not step => just next()
    if (getters.allowStepSwitch) return undefined // => just next()
    if (name === getters.getCurrentStepName) return undefined // => just next()
    return { name: getters.getCurrentStepName }
  },

  /**
   * After each coordinator
   * @description Does important actions after each route switch
   * @param {Object} commit - Wizard SM mutations
   */
  afterEachCoordinator ({ commit }, { name, idx }) {
    commit('SET_SWITCHED_ROUTE_INFO', { name, idx })
  }

}
